import React from 'react';
import { isMobile } from 'react-device-detect';
import { TDHLogo } from '@td-client-frontend/icons';
import ResetPassword from './ResetPassword';

export const ResetPasswordContainer = () => {
  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-full max-w-md mx-auto font-effra" data-testid="rp-container">
        <div className="px-4 pt-6 pb-8 md:px-8">
          <div className="px-4 py-4">
            <TDHLogo title="HY Logo" />
          </div>
          <h1 className="mt-6 py-6" data-testid="titleText">
            Reset Password
          </h1>
          <h3 className="text-gray-25">
            This site cannot be accessed from a mobile device. Please use your desktop computer browser to set the
            password.
          </h3>
        </div>
      </div>
    );
  }
  return <ResetPassword />;
};
